// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"131":"c35678f8","153":"917f037b","317":"df3a43e0","380":"6cae52d5","733":"2a28af54"}[chunkId] + ".css";
};